import Request from "@/common/net/request.js";
const request = new Request();

// 查询阶段分佣配置
export function getConfig() {
  return request.send({
    url: `/pmy/sys/sys/configs/base-info`,
    method: "get"
  });
}

// 设置基础信息配置
export function setConfig(data) {
  return request.send({
    url: `/pmy/sys/sys/configs/base-info`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 上传收款二维码
export function postPaymentQr(data) {
  return request.send({
    url: `/pmy/sys/sys/configs/payment-qr`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 获取收款二维码
export function getPaymentQr() {
  return request.send({
    url: `/pmy/sys/sys/configs/payment-qr`,
    method: "get"
  });
}
